<template>
  <div class="dropdown-menu" :class="{ unactive: isActive }">
    <nav v-for="element in elements" :key="element.route">
      <menu-element :routingTo="element.route" :content="element.content" :logoName="element.logoName" /> 
    </nav>
  </div>
</template>

<script>
import MenuElement from './MenuElement.vue'
export default {
  name: "DropdownMenu",
  components: {
    MenuElement
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    elements: {
      type: Array
    }
  },
  data() {
    return {
      unactive: false
    }
  },
}
</script>

<style>
.dropdown-menu {
  display: block;
  width: 15%;
  min-width: 150px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #FAFAFA;
  transition: display 3s;
}
</style>